import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoelsCmsLinkComponent, CmsComponentData } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { SafeCheckPipe, UrlTargetPipe } from '@boels/helpers';
import { ButtonComponent } from '../button/button.component';

@Component({
  imports: [
    CommonModule,
    FontAwesomeModule,
    SafeCheckPipe,
    UrlTargetPipe,
    ButtonComponent,
  ],
  selector: 'boels-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss'],
})
export class PrimaryButtonComponent {
  @Input() componentData: CmsComponentData<BoelsCmsLinkComponent>;
  faChevronRight = faChevronRight;
}
